import { render, staticRenderFns } from "./add-rg.vue?vue&type=template&id=7ade4f39&"
import script from "./add-rg.vue?vue&type=script&lang=ts&"
export * from "./add-rg.vue?vue&type=script&lang=ts&"
import style0 from "./add-rg.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports